@if (visible && !disabled && !!headline) {
  <div class="news-popup-overlay" (click)="closed.emit()">
    <div class="news-popup" (click)="$event.stopPropagation()">
      <div class="news-popup__close"><i class="news-popup__close-icon" (click)="closed.emit()"></i></div>
      <div class="news-popup__media"><img src="{{ mediaUrl }}" alt="{{ mediaAltText }}" /></div>
      <div class="news-popup__content">
        <div class="news-popup__description">
          <h2 class="news-popup__headline">{{ headline }}</h2>
          <p class="news-popup__text">{{ description }}</p>
        </div>
        <div class="news-popup__button-panel">
          <a class="news-popup__link" [href]="linkUrl" target="_blank"
            ><button class="btn btn-active--transparent" type="button">{{ linkButtonLabel }}</button></a
            >
            <button class="btn btn-active" type="button" (click)="stopShowing.emit(headline)">
              {{ 'COMMON.DONT_SHOW_AGAIN_TEXT' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
